import { chunkArray } from './array';
import { objectFlip } from './object';

export const splitBy = (string, separator) => chunkArray(string.split(separator), 2).map(parts => parts.join('')).filter(Boolean);
export const splitSentences = (string) => {
  const quoteRegex = new RegExp('«[^»]+»', 'mgi');
  const newSentenceCharRegex = new RegExp(`(${gon.newSentenceCharRegex})`, 'mgi');
  const encodedChar = new RegExp(`[${Object.keys(gon.encodedChar).join('')}]`, 'mgi')
  const decodedChar = new RegExp(`[${Object.values(gon.encodedChar).join('')}]`, 'mgi')

  const stringEncoded = string.replace(quoteRegex, quote =>
    quote.replace(encodedChar, char =>
      gon.encodedChar[char]
    )
  );

  const splittedString = splitBy(stringEncoded, newSentenceCharRegex);

  return splittedString.map(string =>
    string.replace(decodedChar, char =>
      objectFlip(gon.encodedChar)[char]
    )
  )
};
